// extracted by mini-css-extract-plugin
module.exports = {"root":"g_b","dividerAnimation":"g_p"};